var _path, _g, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 19"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  width: 18,
  height: 19,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M0 .5h18v17.996H0V.5Z",
  clipRule: "evenodd"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#1877F2",
  fillRule: "evenodd",
  d: "M18 9.552C18 4.552 13.97.5 9 .5 4.028.499-.002 4.552-.002 9.552c0 4.52 3.291 8.265 7.594 8.944v-6.327H5.308V9.552h2.285V7.558c0-2.27 1.344-3.523 3.4-3.523.984 0 2.014.177 2.014.177V6.44h-1.134c-1.118 0-1.467.698-1.467 1.414v1.698h2.496l-.399 2.617h-2.097v6.327C14.709 17.816 18 14.07 18 9.552Z",
  clipRule: "evenodd"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m12.625 12.053.403-2.622h-2.523v-1.7c0-.718.352-1.417 1.482-1.417h1.148V4.082s-1.041-.177-2.037-.177c-2.079 0-3.437 1.255-3.437 3.528v1.998h-2.31v2.622h2.31v6.337a9.203 9.203 0 0 0 2.844 0v-6.337h2.12Z",
  clipRule: "evenodd"
})));
export default SvgFacebook;